<img [src]="incentive.img" alt="Poll Incentive">
<h3>{{ incentive.title }}</h3>
<p>{{ incentive.description }}</p>
<h3 *ngIf=" type === 'winner' &&  drawNumber && drawNumber > 0"> {{ drawNumber }} </h3>
<button (click)="btnOnClick()"> {{ btnDescription }}</button>
